export default {
  header: {
    language: 'Language',
    portuguese: 'Portuguese',
    english: 'English',
    home: 'Home',
    services: 'Services',
    about: 'About',
    youtube: 'Youtube',
    games: 'Games',
  },
  not_found: {
    title: 'Page not found',
    return: 'Return to the',
  },
  footer: {
    info: 'All rights reserved',
  },
  home: {
    intro: 'Specialized consulting services, with focus on software development and cloud computing',
    additional: 'We create customized and optimized solutions, according to your needs, to ensure excellent performance and cost-effectiveness',
  },
  cookies_policy: {
    cookies_preferences: 'Your cookie preferences',
    policy: 'Cookies Policy',
    header: 'We use cookies to optimize our website and collect usage statistics.',
    info_1_header: 'Information about our use of cookies',
    info_1_text: 'This website uses cookies to provide users with a good browsing experience, also allowing us to improve it.',
    info_2_header: 'What is a cookie?',
    info_2_text: 'A cookie is a small file of letters and numbers that we store in the user\'s browser or on the hard disk (HD) of their computer, as long as the user agrees. Cookies contain information that is transferred to the hard disk of the user\'s computer.',
    accept_cookies: 'Accept cookies',
  },
  services: {
    article_1_title: 'WIKI PEP',
    article_1_info: 'WIKI PEP is a platform for consulting and researching Politically Exposed Persons (PEPs), providing detailed information about their identities, public offices, political history, and relevant connections',
    article_1_link_text: 'Access WIKI PEP',
  },
  about: {
    article_1_text_1: 'Blackdevs is a company founded in 2018, with the objective of helping other companies to leverage their business with the help of technology, automating manual processes, reducing costs, using what\'s available of most modern in the world of technology',
    article_1_text_2: 'The founder is an experienced developer with a solid foundation in software development, cloud computing, and AI. Proficient in building REST APIs and backend services using NodeJS, TypeScript, Python, Java, and Golang, with a focus on microservices and serverless architectures running on cloud environments',
    article_2_title: 'Founder',
    article_2_text_1: 'Certificate in Cloud Computing',
  },
  youtube: {
    title: 'Youtube Channel',
    latest_videos: 'Latest videos',
    loading: 'Loading',
    subscribers: 'Subscribers',
    views: 'Views',
  },
  games: {
    latest_games: 'Latest games',
    loading: 'Loading',
    downloads: 'Downloads',
  },
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    clear: 'Clear fields',
    return: 'Return',
    login: 'Login',
  },
  messages: {
    errors: {
    },
    success: {
    },
  },
  dates: {
    long_date_format: {
      LT: 'h:mm A',
      LTS: 'h:mm:ss A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM [de] D [de] YYYY',
      LLL: 'MMMM [de] D [de] YYYY h:mm A',
      LLLL: 'dddd, MMMM [de] D [de] YYYY h:mm A',
    },
    previous_month: 'Previous Month',
    next_month: 'Next Month',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    weekdays: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    weekdays_short: [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat',
    ],
  },
  validations: {
    messages: {
      _default: 'Invalid fields',
    },
  },
};
